import './App.css';
import 'antd/dist/reset.css'
import { RouterProvider } from 'react-router-dom';

import { QueryClientProvider, QueryClient } from 'react-query';
import { Irouter } from './router/router';
import { ConfigProvider } from 'antd';
import { themeConfig } from './utils/themeConfig';
import { useEffect } from 'react';
import { setFaviconTitle } from './utils/functions';

function App() {
	const queryClient = new QueryClient();

  useEffect(() => {
    // 앱이 처음 로드될 때 도메인 기준으로 파비콘, 타이틀 설정
    setFaviconTitle();
  }, []);
	
	return (
		<QueryClientProvider client={queryClient}>
			<ConfigProvider theme={themeConfig}>
				<RouterProvider router={Irouter}>
					<div className="App" />
				</RouterProvider>
			</ConfigProvider>
		</QueryClientProvider>
	);
}

export default App;
